module.exports = __webpack_public_path__ + "img/cq-bg-table-1.6b50ecfc.jpg";